import { render, staticRenderFns } from "./FolderTaskBandItem.vue?vue&type=template&id=01f3832b&scoped=true"
import script from "./FolderTaskBandItem.vue?vue&type=script&lang=js"
export * from "./FolderTaskBandItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f3832b",
  null
  
)

export default component.exports